import * as Yup from "yup";

export const BookingDateConfirmSchema = Yup.object().shape({
  client_id: Yup.number(),
  start_date: Yup.date().required("Please, choose the start date"),
  end_date: Yup.date().nullable(),
  include_weekends: Yup.boolean().required(),
});
